import React, { useState } from 'react';
import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';
import toast from 'react-hot-toast';

const UpdateProfile = () => {
  const [updating, setUpdating] = useState(false);
  const [result, setResult] = useState(null);

  const updateProfile = async () => {
    setUpdating(true);
    setResult(null);

    try {
      const updateUserProfileFunction = httpsCallable(functions, 'updateUserProfile');
      const response = await updateUserProfileFunction();
      
      setResult({
        success: true,
        message: response.data.message,
        uid: response.data.uid
      });
      
      toast.success('User profile updated to super_admin! Please refresh the page.');
    } catch (error) {
      console.error('Profile update failed:', error);
      setResult({
        success: false,
        error: error.message,
        code: error.code
      });
      
      toast.error(`Profile update failed: ${error.message}`);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-2xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              🔧 Update User Profile to Super Admin
            </h1>
            <p className="text-gray-600">
              Update Firestore user profile for christheale@gmail.com
            </p>
          </div>

          <div className="space-y-6">
            <button
              onClick={updateProfile}
              disabled={updating}
              className={`w-full py-3 px-4 rounded-md font-medium ${
                updating
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700'
              } text-white transition-colors`}
            >
              {updating ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Updating Profile...
                </span>
              ) : (
                '📝 Update Profile to Super Admin'
              )}
            </button>

            {result && (
              <div className={`p-4 rounded-md ${
                result.success 
                  ? 'bg-green-50 border border-green-200' 
                  : 'bg-red-50 border border-red-200'
              }`}>
                <div className="flex">
                  <div className="flex-shrink-0">
                    {result.success ? (
                      <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    ) : (
                      <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                  <div className="ml-3">
                    <h3 className={`text-sm font-medium ${
                      result.success ? 'text-green-800' : 'text-red-800'
                    }`}>
                      {result.success ? 'Success!' : 'Error'}
                    </h3>
                    <div className={`mt-2 text-sm ${
                      result.success ? 'text-green-700' : 'text-red-700'
                    }`}>
                      <p>{result.success ? result.message : result.error}</p>
                      {result.uid && (
                        <p className="mt-1 text-xs opacity-75">
                          User ID: {result.uid}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <h4 className="text-sm font-medium text-blue-800 mb-2">
                📋 What This Does:
              </h4>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• Updates Firestore user profile role to 'super_admin'</li>
                <li>• Adds all super admin permissions</li>
                <li>• Matches your production profile settings</li>
                <li>• Enables super admin dashboard access</li>
              </ul>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <h4 className="text-sm font-medium text-yellow-800 mb-2">
                ⚠️ After Update:
              </h4>
              <ul className="text-sm text-yellow-700 space-y-1">
                <li>• Go to /force-refresh and click "Force Reload"</li>
                <li>• Check that Auth Debug shows role: super_admin</li>
                <li>• Access /super-admin dashboard</li>
                <li>• Test clinic creation with welcome emails</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfile;
